/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Michael Shaffer
 * Date: 2/21/18
 * Copyright All Rights Reserved
 */

import React from 'react';
import { Link } from 'react-router-dom';

const NoReportsCTA = () => (
  <div className="report-cta">
    <div className="row">
      <div className="col-xs-8 col-xs-offset-2 text-center">
        <h3 className="text-muted">
          Looks like you are ready to create your first Site Hazard report!
        </h3>
        <Link to="/inputs" type="button" className="btn btn-lg btn-primary">
          Get Started Now!
        </Link>
      </div>
    </div>
  </div>
);

export default NoReportsCTA;
